/* eslint-disable */
import { store } from '../../store'
import { http, httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
    get({ commit, dispatch }, payload) {
        let url = 'api/vendor'
        let options = {
          emulateJSON: false,
          headers: { 'Content-Type': 'application/json' }
        }

        httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
        
        httpgst.get(url, {}, options)
        .then(
          response => {
            commit('onGet', { event: payload.event, response: response })
          },
          error => {
            commit('onError', { event: payload.event, error: error })
          }
        )
    },
    postByExpense({ commit, dispatch }, payload) {
      let url = 'api/vendor'
      let params = {
        name: payload.event.item.vendorSelect,
        is_foreign: payload.event.item.vendor.is_foreign ? 0 : 1,
      }

      if(params.is_foreign === 0) { 
        params.tax_id = payload.event.item.vendor.tax_id,
        params.tax_id_validation_number = payload.event.item.vendor.tax_id_validation_number
      }
      
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

      httpgst.post(url, params, {}).then(
        response => {
          commit('onPostByExpenseUniversal', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
    },
    post({ commit, dispatch }, payload) {
      let url = 'api/vendor'
      let params = {
        name: payload.event.item.vendorSelect,
        is_foreign: payload.event.item.vendor.is_foreign ? 0 : 1
      }

      if(params.is_foreign === 0) { 
        params.tax_id = payload.event.item.vendor.tax_id,
        params.tax_id_validation_number = payload.event.item.vendor.tax_id_validation_number
      }
      
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

      httpgst.post(url, params, {}).then(
        response => {
          commit('onPostByExpenseUniversal', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
    },
}

// mutations
const mutations = {
  onGet(state, payload) {
      payload.event.context.vendors = payload.response.data.data
  },
  onPostByExpenseUniversal(state, payload) {
    payload.event.context.vendors.push(payload.response.data.data)
    payload.event.context.editedItemReceiptUniversal.vendor = payload.response.data.data
    this.dispatch('expensesItems/post', { event: payload.event })
  },
  onError(state, payload) {
      if (payload.error.response.data.errors !== undefined) {
          payload.event.context.errors = payload.error.response.data.errors
      }
      payload.event.context.showNotification(payload.error.response, 'error', -1)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vendors.js